var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.84001C8.5 1.99514 9.99514 0.5 11.84 0.5H39.8179L55.5001 13.673V60.16C55.5001 62.0049 54.0049 63.5 52.1601 63.5H11.84C9.99514 63.5 8.5 62.0049 8.5 60.16V3.84001Z",
    stroke: "#6D7786"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0V9.59996C40 11.721 41.719 13.44 43.84 13.44H56.0001",
    fill: "#6D7786"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2227 45H11.9155V34.3359H14.2227V38.6206H18.3682V34.3359H20.668V45H18.3682V40.4736H14.2227V45Z",
    fill: "#6D7786"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.333 45H25.0332V36.1963H21.8398V34.3359H30.5703V36.1963H27.333V45Z",
    fill: "#6D7786"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7891 34.3359L37.4331 41.9458L40.0698 34.3359H43.0801V45H40.7729V42.2388L41 37.1777L38.2095 45H36.6421L33.8589 37.1777L34.0859 42.2388V45H31.7788V34.3359H34.7891Z",
    fill: "#6D7786"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8545 45H44.9331V34.3359H47.2329V43.147H51.8545V45Z",
    fill: "#6D7786"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.43aa4e70.svg";
export { ForwardRef as ReactComponent };